// Team roster for the About page. The `image` field is the file
// basename under /public/images/team/ — each photo ships as a
// content-cropped 400x400 pair: `{image}-400.webp` (preferred) and
// `{image}-400.jpg` (fallback for browsers without WebP, and as the
// graceful path when a 404 fires).
//
// Order here drives display order — the grid renders in array
// order, no sort, no shuffle (prerender determinism: see CLAUDE.md).
//
// Names repeat (two Tigrans) so we use `image` as the React key —
// it's globally unique by file path.
export interface TeamMember {
  name: string;
  image: string;
}

export const TEAM: TeamMember[] = [
  { name: 'Gor', image: '1' },
  { name: 'Vardan', image: '2' },
  { name: 'David', image: '11' },
  { name: 'Arsen', image: '3' },
  { name: 'Hrayr', image: '9' },
  { name: 'Vadim', image: '4' },
  { name: 'Armen', image: '5' },
  { name: 'Tigran', image: '6' },
  { name: 'Tigran', image: '7' },
  { name: 'Grisha', image: '8' },
  { name: 'Hayk', image: '10' },
];
